import axios from "../helper/Axios.js";
import { adminUrl, mainURL } from "../config/config.js";
import qs from "qs";

export async function getJDCategories({
  categoryName,
  parentId,
  status,
  whParentId,
  syncTo,
  syncToId,
  level,
  limit,
  page
}) {
  try {
    let queryparams = qs.stringify({
      searchQuery: categoryName,
      jdParentId: parentId,
      status,
      whparentid: whParentId,
      syncto: syncTo,
      synctoquery: syncToId,
      level,
      limit,
      page
    })
    let categoryResponse = await axios.Get({
      url: `${mainURL}/product-categories?${queryparams}`
    });
    if (categoryResponse.statusCode !== 200) {
      return { error: categoryResponse.message };
    }
    return { data: categoryResponse.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getJDCategoriesLocal({
  categoryName,
  parentId,
  status,
  whParentId,
  syncTo,
  syncToId,
  level,
  limit,
  page
}) {
  try {
    let queryparams = qs.stringify({
      searchQuery: categoryName,
      jdParentId: parentId,
      status,
      whparentid: whParentId,
      syncto: syncTo,
      synctoquery: syncToId,
      level,
      limit,
      page
    })
    let categoryResponse = await axios.Get({
      url: `${adminUrl}/product-categories?${queryparams}`
    });
    if (categoryResponse.statusCode !== 200) {
      return { error: categoryResponse.message };
    }
    return { data: categoryResponse.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getAllJDCategories({
  searchQuery,
  jdParentId,
  status,
  level,
  limit,
  page
}) {
  try {
    let categoryResponse = await axios.Get({
      url: `${mainURL}/product-categories/all?level=${level || ""}&status=${status ||
        ""}&jdParentId=${jdParentId || ""}&searchQuery=${searchQuery || ""}&limit=${limit || ''}`
    });
    if (categoryResponse.statusCode !== 200) {
      return { error: categoryResponse.message };
    }
    return { data: categoryResponse.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getCategoryDetail(id) {
  try {
    let categoryResponse = await axios.Get({
      url: `${mainURL}/product-categories/${id}`
    });
    if (categoryResponse.statusCode !== 200) {
      return { error: categoryResponse.message };
    }
    return { data: categoryResponse.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function createCategory({
  name,
  orderNumber,
  jdId,
  jdCategoryLevel,
  jdParentId,
  whParentCategoryId,
  margin,
  shippingFee,
  imageUrl,
  isActive,
  region
}) {
  if (margin !== "") {
    margin = margin / 100;
  }
  try {
    let categoryResponse = await axios.Post({
      url: `${mainURL}/product-categories`,
      data: {
        name,
        orderNumber,
        jdId,
        jdCategoryLevel,
        jdParentId,
        margin,
        shippingFee,
        imageUrl,
        isActive,
        region,
        whParentCategoryId
      }
    });
    if (categoryResponse.statusCode !== 200) {
      return { error: categoryResponse.message };
    }

    return { data: categoryResponse.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function updateCategory({
  id,
  name,
  orderNumber,
  jdId,
  jdCategoryLevel,
  jdParentId,
  margin,
  shippingFee,
  imageUrl,
  region,
  isActive,
  currentCategoryOrder,
  syncTo
}) {
  if (margin !== "") {
    margin = margin / 100;
  }
  try {
    let categoryResponse = await axios.Put({
      url: `${mainURL}/product-categories/${id}`,
      data: {
        name,
        orderNumber,
        jdId,
        jdCategoryLevel,
        jdParentId,
        margin,
        shippingFee,
        imageUrl,
        region,
        isActive,
        currentCategoryOrder,
        syncTo
      }
    });
    if (categoryResponse.statusCode !== 200) {
      return { error: categoryResponse.message };
    }

    return { data: categoryResponse.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function toggleCategory(categoryId) {
  try {
    let categoryResponse = await axios.Patch({
      url: `${mainURL}/product-categories/id/${categoryId}/deleted`
    });
    if (categoryResponse.statusCode !== 200) {
      return { error: categoryResponse.message };
    }

    return { data: categoryResponse.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function loadParentCategoryID({ input, currentcategory, synctocategory, currentid }) {
  try {
    let response = await axios.Get({
      url: `${mainURL}/product-categories/query?query=${input}&currentcategory=${currentcategory}&synctocategory=${synctocategory}&currentid=${currentid}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: response.data };
  } catch (error) {
    return { error: error.response.data };
  }
}

export async function loadCategoryOrder(parentid) {
  try {
    let response = await axios.Get({
      url: `${mainURL}/product-categories/current?parentid=${parentid}`
    });
    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
